export default {"src":"/_next/static/media/vtc.e959e33e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};